<template>
  <div class="app">
    <router-view />
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-facing-decorator";
import { authService } from "../services/authServiceInstance";

@Component({})
export default class App extends Vue {
  beforeCreate() {
    authService.init();
  }
}
</script>

<style lang="scss">
// TODO Pretty sure this shouldn't be there.

.app {
  .quill-content-block {
    > span {
      display: block;
      border: 1px solid var(--v-primary-base);
      border-radius: 4px;
      align-items: center;
      width: 100%;
      color: var(--v-primary-base);
      font-size: 1rem !important;
      font-weight: normal !important;
      font-style: normal !important;
      cursor: default;
      padding: 0 1rem;
      > strong {
        display: block;
        margin: 0 -1rem;
        padding: 0 1rem;
        border-radius: 4px;
        background-color: #d2defe;
        text-align: left;
      }
    }
  }

  .quill-variable {
    & > span {
      padding: 0 12px;
      display: inline-flex;
      align-items: center;
      height: 32px;
      background-color: var(--v-primary-base);
      color: white;
      font: inherit;
      border-radius: 4px;
      cursor: default;
    }
    &--success > span {
      background-color: var(--v-success-base);
    }
    &--warning > span {
      background-color: var(--v-warning-base);
    }
  }
}
</style>
